import { createSelector } from '@ngrx/store';

const selectGmail = (state: any) => {
  return state.google;
};

export const selectGmailsSuccess = createSelector(
  selectGmail,
  (state) => state.gmails
);

export const selectGmailsFailure = createSelector(
  selectGmail,
  (state) => state.error
);
